import { useIsMutating } from '@tanstack/react-query';
import { API_TAGS } from '../lib/constants';
import { useWorkspaceStore } from '../stores/workspace';

export function useCurrentWorkspace() {
  const { currentWorkspace, ...rest } = useWorkspaceStore();
  const mutations = useIsMutating({ mutationKey: [API_TAGS.SaveWorkspace] });

  const currentWorkspaceId = currentWorkspace ? currentWorkspace.workspace_id : null;

  return {
    currentWorkspace,
    currentWorkspaceId,
    isSavingWorkspace: !!mutations,
    ...rest,
  };
}
